import type { FC } from "react";
import Button from "@ch/components/Buttons/Button";
import Icon from "@ch/components/Icons/Icon";
import { useNavigate } from "react-router-dom";

const ConsentSuccess: FC = () => {
  const navigate = useNavigate();
  return (
    <div className="w-[460px] rounded-3xl border-2 border-[#E5E7EB] bg-white px-8 pb-9 pt-10">
      <div className="mb-4 flex items-center justify-center">
        <div className="flex h-[72px] w-[72px] items-center justify-center rounded-full bg-[#C9ECDA]">
          <Icon color="#255F41" name="check-mark-2" size={32} />
        </div>
      </div>

      <h2 className="mb-4 text-center text-2xl font-bold text-black">
        Consent Email Sent
      </h2>

      <div className="mx-auto mb-8 max-w-[360px] text-center text-sm leading-6 text-ink-600">
        <p className="mb-3">
          Thank you for providing your guardian / parents details. We have sent
          a consent form to the provided contact details.
        </p>
        <p>
          You will be notified once we receive your parents / guardian consent.
          Please have patience till then and explore mDoc other features.
        </p>
      </div>

      <Button
        buttonStyle="w-full"
        className="btn btn-primary rounded-xl"
        onClick={() => void navigate("/", { replace: true })}
        type="button"
      >
        Close
      </Button>
    </div>
  );
};

export default ConsentSuccess;
